import { useState } from 'react';
import { Button } from 'primereact/button';

const ExpandableText = ({
  text,
  limit,
  buttonClassName,
}: {
  text: string;
  limit: number;
  buttonClassName?: string;
}) => {
  const [expanded, setExpanded] = useState(false);
  const isLong = text.length > limit;

  let displayText = text;

  if (isLong && !expanded) {
    displayText = `${displayText.slice(0, limit)}…`;
  }

  return (
    <div className="flex flex-col items-end gap-2 text-sm mb-4 whitespace-pre-wrap">
      <span className="w-full">{displayText}</span>
      {isLong && (
        <Button
          label={expanded ? 'Show less' : 'Show more'}
          onClick={() => setExpanded(!expanded)}
          className={buttonClassName}
        />
      )}
    </div>
  );
};

ExpandableText.defaultProps = {
  buttonClassName: '',
};

export default ExpandableText;
